export default 'redux-responsive/CALCULATE_RESPONSIVE_STATE';


//////////////////
// WEBPACK FOOTER
// ./~/redux-responsive/lib/actions/types/CALCULATE_RESPONSIVE_STATE.js
// module id = 230
// module chunks = 0